import { authorizationType } from '#authorization/constants'
import { newAuthorizationSlot } from '#authorization/model'
import { avlPrefix, avlType } from '#avl/constants'
import { detailsType, fishingKindTag } from '#details/constants'
import { useDetailsRowParser } from '#details/parser'
import { MigrationItem, useAvlRowParser } from '#migration/migration-avl'
import { photographType } from '#photographs/constants'
import { newPhotoSlot } from '#photographs/model'
import { RavRecord } from '#record/model'
import { iotcnumberscheme } from '#vid/constants'
import { useVID } from '#vid/model'
import { utils } from 'apprise-core/utils'
import { XlsXParseContext } from 'apprise-frontend-parse/file'
import { ParseContext } from 'apprise-frontend-parse/model'
import { useDefaultModelParser, useDefaultParser } from 'apprise-frontend-parse/resource'
import { useDefaultBookParser } from 'apprise-frontend-parse/workbook'
import { useAsyncTask } from 'apprise-ui/utils/asynctask'
import { avlmigrationConfig } from './config.avl'



export const useAvlExternalMigration = (rows?: number) => {

    const config = rows ? { ...avlmigrationConfig, rowRadius: rows } : avlmigrationConfig

    const itemParser = useAvlExternalMigrationItemParser()
    const modelparser = useDefaultModelParser(itemParser)
    const bookparser = useDefaultBookParser(modelparser, 'external', () => config)

    const parse = useDefaultParser<RavRecord, ParseContext<XlsXParseContext>>({ modelparser, bookparser })

    const migrate = async (props: { file: File }) => {

        const { file } = props

        console.log(`migrating ${rows || 'all'} record from ${file.name}`)

        const resource = { id: file.name, name: file.name, file }

        return await parse(resource, {})

    }

    const task = useAsyncTask()

    return task.make(migrate).with(config => config.notify().wait(100).show(({ file }) => `migrating ${rows || 'all'} records...`)).done()

}




const useAvlExternalMigrationItemParser = () => {

    const vids = useVID()

    const parseDetails = useDetailsRowParser()
    const parseAvl = useAvlRowParser()


    return (row: MigrationItem): RavRecord => {

        const timestamp = new Date(row.date)

        const declaration = parseAvl(row)
        const tenant = declaration.tenant
        
        if (row.flagstate && tenant === row.flagstate) 
            throw new Error(`unknown flag state ${row.flagstate}`)

        const details = parseDetails(row,{})[detailsType]

        if (row.type && details.vesselType === row.type) 
            throw new Error(`unknown vessel type ${row.type}`)
        
        if (row.gear && details.gears?.[0] === row.gear) 
            throw new Error(`unknown gear type ${row.gear}`)
       
        details.timestamp = timestamp.toISOString()
        details.vesselKind = fishingKindTag
        details.flagstate = tenant        
        
        const emptyauthz = newAuthorizationSlot()
        emptyauthz.timestamp = timestamp.toISOString()

        const emptyphotos = newPhotoSlot()
        emptyphotos.timestamp = timestamp.toISOString()

        return {

            id: utils().mint('R'),
            uvi: row.uvi ? vids.stringify(iotcnumberscheme, `IOTC${row.uvi?.padStart(6, '0')}`) : undefined!,
            tenant,
            timestamp: timestamp.toISOString(),
            scope: 'external',
            cmm: '10/08',
            origin: undefined!,
            aliases:[],

            lifecycle: {
                state: 'published',
                lastModified: timestamp.getTime(),
                created: timestamp.getTime(),
                lastModifiedBy: 'apprise-support'
            },

            patchedSlots: [detailsType, avlType],

            [detailsType]: details,
            [authorizationType]: emptyauthz,
            [photographType]: emptyphotos,

            [avlType]: {
                id: utils().mint(avlPrefix),
                timestamp: timestamp.toISOString(),
                declarations: [declaration]
            },

            

        } as RavRecord



    }

}

